<template>
  <div class="notice" ref="notice">
    <slot>
      <ul>
        <li
          v-for="(item, index) in data"
          :key="index"
          @click="clickItem(item.id)"
        >
          {{ item.title }}
        </li>
      </ul>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: function() {
        return [];
      }
    },
    type: {
      // 1公告
      type: Number,
      default: 0
    },
    limitMoveNum: {
      type: Number,
      default: 0
    },
    speed: {
      type: Number,
      default: 3000
    }
  },
  components: {},
  data() {
    return {
      index: 0,
      close: true
    };
  },
  created() {},
  mounted() {
    this.getNotice();
  },
  computed: {},

  methods: {
    clickItem(id) {
      // 点击公告
      if (this.type) {
        this.$router.push({
          path: "/notice",
          name: "notice",
          query: { type: 1, id: id }
        });
      }
    },
    getNotice() {
      this.liHeight = this.$refs.notice.children[0].children[0].offsetHeight;
      // console.log(this.liHeight)
      // this.liNum = this.$refs.notice.children[0].children.length;
      if (this.limitMoveNum && this.data.length > this.limitMoveNum) {
        this.$refs.notice.innerHTML =
          this.$refs.notice.innerHTML + this.$refs.notice.innerHTML;
        this.setTime();
      }
      if (!this.limitMoveNum) {
        this.setTime();
      }
    },
    setTime() {
      if (this.index == this.data.length) {
        this.index = 0;
        this.setNotince = setTimeout(() => {
          this.$refs.notice.style["transform"] = "translate3d(0px, 0px, 0px)";
          this.$refs.notice.style["transition"] = "transform 0ms ease 0s";
        }, 300);
      }
      this.setNotince2 = setTimeout(() => {
        this.index++;
        this.$refs.notice.style["transform"] =
          "translate3d(0px, -" + this.liHeight * this.index + "px, 0px)";
        this.$refs.notice.style["transition"] = "transform 300ms ease 0s";
        this.setTime();
      }, this.speed);
    }
  },
  watch: {},
  beforeDestroy() {
    clearTimeout(this.setNotince);
    clearTimeout(this.setNotince2);
  }
};
</script>

<style lang="less" scoped>
.notice {
  ul {
    transition: transform 300ms ease 0s;
    li {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #4a4a4a;
      font-size: 12px;
      text-align: left;
    }
  }
}
</style>
